import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import useCompanyHeader from '../../../../../common/category/useCompanyHeader'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { SelectCustom } from '../../../../../common/selectCustom'
import EventEmitter, {
  SHOW_POPUP_BUY_REPORT,
  SHOW_POPUP_UPGRADE,
} from '../../../../../helpers/EventEmitter'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import { SOURCE, TYPE_OF_FS } from '../../constant'
import {
  changeIsShowCommonSize,
  changeSource,
  changeTypeOfFS,
  selectDataYears,
  selectIsShowCommonSize,
  selectSource,
  selectTypeOfFS,
} from '../../store/slice'
import {
  downloadFinancialData,
  financialStatementsTable,
} from '../../store/thunk'
import classes from './FilterTable.module.scss'

export const FilterTable = ({ auditStatuses, methods, ids = [] }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const userType = useSelector(selectUserType)
  const isShowCommonSize = useSelector(selectIsShowCommonSize)
  const source = useSelector(selectSource)
  const typeOfFS = useSelector(selectTypeOfFS)
  const years = useSelector(selectDataYears)
  const { currency, multiplier, unitName } = useFormatCurrency(
    SCREEN.FINANCIAL_STATEMENT,
  )
  const { companyHeader } = useCompanyHeader({ disableCallApi: true })

  const organizationIdParams = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  }).organizationId

  const onToggle = () => {
    dispatch(changeIsShowCommonSize(!isShowCommonSize))
  }

  const params = {
    organizationId: organizationIdParams,
    sourceOrganizationId: source?.value,
    isConsolidated: typeOfFS?.value === TYPE_OF_FS.consolidated.value,
    auditStatuses,
    methods,
    years: years?.length ? years : undefined,
  }

  const onChangeSource = (e) => {
    dispatch(changeSource(e))
    dispatch(
      financialStatementsTable({
        ...params,
        sourceOrganizationId: e.value,
        auditStatuses: undefined,
        methods: undefined,
        isConsolidated: undefined,
        years: undefined,
      }),
    )
  }

  const onChangeTypeOfFS = (e) => {
    dispatch(changeTypeOfFS(e))
    dispatch(
      financialStatementsTable({
        ...params,
        isConsolidated: e.value === TYPE_OF_FS.consolidated.value,
        auditStatuses: undefined,
        methods: undefined,
        years: undefined,
      }),
    )
  }

  const downloadFile = () => {
    if (userType.userTypeId !== USER_TYPE.PREMIUM) {
      return EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }

    if (
      userType.userTypeId === USER_TYPE.PREMIUM &&
      !companyHeader.allowDynamicReport
    ) {
      return EventEmitter.dispatch(SHOW_POPUP_BUY_REPORT)
    }

    if (!ids.length) return

    const params = {
      currency,
      currencyUnit: { multiplier, value: unitName, en_Value: unitName },
      organizationId: organizationIdParams,
      sourceOrganizationId: source?.value,
      isConsolidated: typeOfFS?.value === TYPE_OF_FS.consolidated.value,
      auditStatuses: auditStatuses,
      methods: methods,
      years,
    }
    dispatch(downloadFinancialData(params))
  }

  return (
    <Element className={classes.filterContainer}>
      <Element
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '0 12px',
          borderRightWidth: 1,
          borderRightStyle: 'solid',
          borderRightColor: '#d5d5d5',
        }}
      >
        <Translate value="financialStatement.SOURCE" />
        <SelectCustom
          activeItem={source}
          data={Object.values(SOURCE).filter(
            (item) => item.value !== SOURCE.creditFiling.value,
          )}
          isI18n={true}
          chooseItem={(e) => onChangeSource(e)}
          style={{
            border: 'none',
            paddingLeft: '4px',
            fontSize: 12,
            paddingRight: '27px',
          }}
          scrollId="companyAnalysis"
        />
      </Element>
      <Element
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '0 12px',
          borderRight: '1px solid #d5d5d5',
        }}
      >
        <Translate value="financialStatement.TYPE_OF_FS" />
        <SelectCustom
          activeItem={typeOfFS}
          isI18n={true}
          data={Object.values(TYPE_OF_FS)}
          chooseItem={(e) => onChangeTypeOfFS(e)}
          style={{
            border: 'none',
            paddingLeft: '4px',
            fontSize: 12,
          }}
          scrollId="companyAnalysis"
        />
      </Element>
      <Element
        className="dFlex alignItemsCenter"
        style={{
          paddingRight: '12px',
          paddingLeft: '12px',
          borderRightWidth: 1,
          borderRightStyle: 'solid',
          borderRightColor: '#D5D5D5',
        }}
      >
        <div onClick={onToggle} style={{ margin: 'auto 0' }}>
          <Icon
            className={
              isShowCommonSize ? 'icon-checkbox-check' : 'icon-checkbox-uncheck'
            }
            style={{
              color: isShowCommonSize ? '#2C73E8' : '#9C9C9C',
              fontSize: 16,
              margin: '0 2px',
            }}
          />
        </div>
        <span
          style={{ marginLeft: 4 }}
          className="cursorPointer"
          onClick={onToggle}
        >
          <Translate value="financialStatement.COMMON_SIZE_YOY_GROWTH" />
        </span>
      </Element>
      <div onClick={downloadFile} className={classes.download}>
        <Icon
          className="icon-download"
          style={{
            fontSize: 16,
            padding: '0 4px',
            color: !ids.length ? '#9C9C9C' : '#0553A5',
          }}
        />
      </div>
    </Element>
  )
}
